export default __webpack_public_path__ + "static/media/cri.9309d6a5.svg";